import { render, staticRenderFns } from "./field-format-phone.vue?vue&type=template&id=ac18371c"
import script from "./field-format-phone.vue?vue&type=script&lang=js"
export * from "./field-format-phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports